import { GetManhattanDistance } from "./types";

/**
 * Calculate Manhattan (L-shaped) distance between two points.
 */
export const getManhattanDistance: GetManhattanDistance = ({
  pointA,
  pointB,
}) => {
  return Math.abs(pointB.x - pointA.x) + Math.abs(pointB.y - pointA.y);
};
